<template>
  <!--  设备信息档案审批流-->
  <div style="width: 100%;padding-top: 60px">
    <div style="position: fixed;top: 0;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="设备信息档案" name="1">
        <van-field label="物业项目名称" v-model="inputForm.projectName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="管理编码" v-model="inputForm.managementCode" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
<!--        <van-field label="设备编码" v-model="inputForm.equipmentCode" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>-->
        <van-field label="设备名称" v-model="inputForm.name" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="设备类型" v-model="inputForm.equipmentTypeIdName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="设备等级" v-model="inputForm.equipmentLevelIdName" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="安装位置" v-model="inputForm.location" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="备注" v-model="inputForm.remarks" readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
<!--        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
<!--      <van-collapse-item title="附件信息" name="2" v-show="inputForm.attachList.length > 0">-->
<!--        <a style="display: block;" :key="index" v-for="(file,index) in inputForm.attachList"-->
<!--           :href="file.url">{{ file.name }}</a>-->
<!--      </van-collapse-item>-->
      <van-collapse-item title="生产信息" name="2">
        <van-field label="生产日期" v-model="inputForm.extraInfo.productionDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="启用日期" v-model="inputForm.extraInfo.startDate" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="质保时长" v-model="inputForm.extraInfo.warrantyDuration" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="质保期限" v-model="inputForm.extraInfo.warrantyPeriod" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="生产商名称" v-model="inputForm.extraInfo.manufacturerName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="生产商联系人" v-model="inputForm.extraInfo.manufacturerLinkman" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="生产商联系电话" v-model="inputForm.extraInfo.manufacturerPhone" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="生产商联系地址" v-model="inputForm.extraInfo.manufacturerAddress" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="生产商备注" v-model="inputForm.extraInfo.manufacturerRemarks" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      </van-collapse-item>
      <van-collapse-item name="3" title="供应商信息">
        <van-field label="供应商名称" v-model="inputForm.extraInfo.supplierName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="供应商联系人" v-model="inputForm.extraInfo.supplierLinkman" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="供应商联系电话" v-model="inputForm.extraInfo.supplierPhone" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="供应商联系地址" v-model="inputForm.extraInfo.supplierAddress" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="供应商备注" v-model="inputForm.extraInfo.supplierRemarks" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
      </van-collapse-item>
      <van-collapse-item title="关联设备信息" name="4">
        <b-table id="my-table" class="bgc-dark" small head-variant="dark" responsive bordered
                 :items="items" :fields="fields">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width:  field.key === 'index' ?'40px':'100px'}"
            />
          </template>
        </b-table>
      </van-collapse-item>
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {queryById, startFlow, equipmentList} from '../../api/equipment/EquipmentInfoFile.js'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "equipmentInfoFile",
  data() {
    return {
      isshow: false,
      activeNames: ['1', '2', '3', '4'],
      inputForm: {
        id: '',
        projectId: '',
        managementCode: '',
        equipmentCode: '',
        // identificationCode: '',
        name: '',
        equipmentTypeId: '',
        equipmentLevelId: '',
        // enabledStatus: '1',
        // runningStatus: '1',
        location: '',
        remarks: '',
        attachIds: [],
        attachList: [],
        extraInfo: {
          equipmentId: '',
          productionDate: '',
          startDate: '',
          warrantyPeriod: undefined,
          warrantyDuration: '',
          manufacturerName: '',
          manufacturerLinkman: '',
          manufacturerPhone: '',
          manufacturerAddress: '',
          manufacturerRemarks: '',
          supplierName: '',
          supplierLinkman: '',
          supplierPhone: '',
          supplierAddress: '',
          supplierRemarks: ''
        },
        isDoTask: false,
        isLastTask: false,
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'managementCode', label: '管理编码'},
        {key: 'name', label: '设备名称'},
        {key: 'equipmentTypeIdName', label: '设备类型'},
      ],
      items: [],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      queryById(id).then(({data}) => {
        this.inputForm = data
        this.getEquipmentList()
      }).catch(e => {
        console.log(e)
      })
    },
    getEquipmentList(){
      equipmentList({
        'current': '1',
        'size': 50,
        projectId: this.inputForm.projectId,
        id: this.inputForm.id,
        associatedId: this.inputForm.associatedId
      }).then(({data}) => {
        this.items = data.records
      });
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status === '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>

</style>